///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const PrevNextButtonIcon = ({
  height,
  fill,
  title = messages.chevron.defaultMessage,
  width,
  rotateDegree = 0,
  style,
  ...props
}) => (
  <svg
    aria-labelledby="chevron"
    height={height}
    width={width}
    style={{ transform: `rotate(${rotateDegree}deg)`, ...style }}
    {...props}
  >
    <title id="chevron-icon">{title}</title>
    <path fill={fill} d="m6.3 12 1.41-1.41L3.13 6l4.58-4.59L6.3 0l-6 6 6 6Z" />
  </svg>
);

export default PrevNextButtonIcon;
